import { Col, Divider, Modal, Row, Slider, Space, Tag, InputNumber } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useMemo, useState } from "react";

import { Button } from "components/elements";
import { DatePicker, Input, RadioGroup, Select } from "components/form";

import { useTranslation } from "react-i18next";
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/yearAccumulateSchema";
import styles from "../styles/YearAccumulateFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";

const YearAccumulateFilter = ({

  amountIncomeDeductionOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { modifiedStatus = [] } = useStatusFlagOption()
  console.log("man ", modifiedStatus);
  // const modifiedStatus = useMemo(() => {
  //   return statusOptions.map((opt) => ({
  //     ...opt,
  //     label: opt.label,
  //     value: opt.value
  //   }))

  // })



  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={(values) => {
        onSubmit({
          ...values,
          statusFlage: '',
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (
          <Form>
            <Row gutter={[24, 16]} className={styles.filter} >
              <Col span={8}>
                <Input
                  name="accumulateName"
                  label={t("year_accumulate_list.label.Accumulate_name")}
                  placeholder={t("year_accumulate_list.label.Accumulate_name")}
                  size="large"
                />
              </Col>
              <Col span={8}>
                <Select
                  name="incomeDeductionId"
                  placeholder={
                    t("year_accumulate_list.label.Amount_Income_Deduction")
                  }
                  size="large"
                  label={
                    t("year_accumulate_list.label.Amount_Income_Deduction")

                  }
                  options={amountIncomeDeductionOptions}
                  onChange={(val) => {
                    const amountIncomeDeduction =
                      (
                        amountIncomeDeductionOptions.find(
                          (d) => d.value === val
                        ) || {}
                      ).nameEn || "";
                    setFieldValue("amountIncomeDeduction", amountIncomeDeduction);
                  }}
                />
              </Col>
              <Col span={8}>
                <Select
                  name="statusFlag"
                  label={t('year_accumulate_list.label.status')}
                  placeholder={t('year_accumulate_list.label.status')}
                  size="large"
                  options={modifiedStatus}
                />
              </Col>

            </Row>
            <Row justify="end">
              <Space size={24} className={styles.filterbtn}>
                <Button type="default" onClick={resetForm}>
                  {t('cancel-1').toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit">
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default YearAccumulateFilter;
